module.exports = __webpack_public_path__ + "22a7416cf308845a7b8c5431257cfc48.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-17.png
// module id = 2220
// module chunks = 0